module.exports = __webpack_public_path__ + "img/Help.8d189d9f.svg";